import configdata from "./config.json";
import httpService from "./httpService";
let apiEndpoint = "";
if (process.env.NODE_ENV !== "production") {
  apiEndpoint = configdata.apiUrl + "/users";
} else {
  apiEndpoint = configdata.herokuUrl + "/users";
}

export async function register(user) {
  const response = await httpService.post(`${apiEndpoint}/`, user);
  console.log(response);
  return response;
}

export async function register22(user) {
  const response = await httpService.post(`${apiEndpoint}/signup22`, user);
  console.log(response);
  return response;
}

export async function resendEmail(email, actual) {
  
  const response = await httpService.post(
    `${apiEndpoint}/resendConfirmation`,
    {
      email: email,
      actual: actual
    }
  );
  console.log(response);
  return response;
}

export async function getTeam() {
  let data = await httpService.get(`${apiEndpoint}/getTeamMembers`);
  console.log(data);
  return data;
}

export async function getUserProfile(email) {
  let data = await httpService.get(`${apiEndpoint}/getUserProfile/${email}`);
 
  return data;
}

export async function getProfile() {
  let data = await httpService.get(`${apiEndpoint}/getProfile`);
 
  return data;
}

export async function updateProfile(data) {
  let user = await httpService.post(`${apiEndpoint}/updateProfile`, data);
  console.log(user);
  return user;
}
// 
export async function updatePhoneFromSettings(data) {
  // alert("vvvv",data)
  let user = await httpService.post(`${apiEndpoint}/updatePhoneFromSettings`, data);
  console.log(user,"ssssss");
  return user;
}




export async function deleteAccount() {
 
  let token = sessionStorage.getItem("token");
  let user = await httpService.post(`${apiEndpoint}/deleteAccount`, {
    token: token,
  });
  console.log(user);
  return user;
}

export async function deleteTempAccount() {
 
  let token = sessionStorage.getItem("token");
  let user = await httpService.post(`${apiEndpoint}/deleteTempAccount`, {
    token: token,
  });
  console.log(user);
  return user;
}

export async function deleteTeam(data) {
  const team = await httpService.post(`${apiEndpoint}/deleteTeamMembers`, data);
  console.log(team);
  return team;
}

export async function getExpiryDate() {
  let data = await httpService.get(`${apiEndpoint}/getExpiryDate`);
  return data;
}


export async function submitContactForm(data) {
  let response = await httpService.post(`${apiEndpoint}/sendForm`,data);
  return response;
}

export async function sendQuestions(data) {
  let response = await httpService.post(`${apiEndpoint}/sendQuestions`,data);
  return response;
}

export async function addUserToTeam(data) {
  console.log('addUserToTeam',data);
  let response = await httpService.post(`${apiEndpoint}/addToTeam`,data);
  return response;
}

export async function fetchUserData(data) {
  console.log(data)
  let response = await httpService.post(`${apiEndpoint}/fetchUserData`,data);
  return response;
}

export async function changeOrgDetails(data) {
  let response = await httpService.post(`${apiEndpoint}/changeOrgDetails`,data);
  return response;
}

export async function switchRole(data) {
  let response = await httpService.post(`${apiEndpoint}/switchRole`,data);
  return response;
}

export async function getUserRoleCount(data){
let response = await httpService.post(`${apiEndpoint}/getUserRoleCount`,{data});
return response;
}

// Please add all the user related api call here as per the above format

export default {
  //export all the above mentioned api call functions here
  register,
  register22,
  getTeam,
  getUserProfile,
  getProfile,
  updateProfile,
  // OTPRequest,
  deleteTeam,
  deleteAccount,
  getExpiryDate,
  resendEmail,
  addUserToTeam,
  fetchUserData,
  deleteTempAccount,
  sendQuestions,
  getUserRoleCount
};
